import { Col, Row } from "antd";
import React from "react";

interface Props {
  title: string;
  count: number;
  icon?: string;
}
const Card = ({ title, count, icon }: Props) => {
  return (
    <div
      style={{
        padding: 20,
        textAlign: "left",
        boxShadow: "0px 2px 13px 1px lightgray",
        borderRadius: 12,
        background: 'white',
        marginBottom: 20
      }}
    >
      <div>
        <h4 style={{ margin: 0 }}>{title}</h4>
        <h2 style={{ margin: 0 }}>{count}</h2>
      </div>
      {icon && <img src={icon} />}
    </div>
  );
};
export default Card;
